import { Stack } from "@mui/material";
import { PlaybookTitle } from "./PlaybookTitle";
import { UlList } from "./UlList";

export const CRMNotes = ({
  list,
  topic,
}: {
  list: string[];
  topic: string;
}) => {
  return (
    <Stack gap={"20px"} id={topic}>
      <PlaybookTitle text={topic} />
      <UlList text={[]} items={list} />
    </Stack>
  );
};
